export default "__VITE_ASSET__3c295151__"